import "./Education.css";
import School from "./School";
import school_list from "./school_list";
import Footer from "../Home/Footer";
import { Fade } from "react-reveal";
const Education = (props) =>{
    return (
        <div id={props.id} className="education-container">
            <Fade up><h1 className="school-title">My <span className="highlighted-text">Education</span></h1></Fade>
            <hr></hr>
            <Fade left><School name={school_list[0].name} year={school_list[0].year} image={school_list[0].image} grade={school_list[0].grade} description={school_list[0].description} degree={school_list[0].degree} /></Fade>
            <Fade right><School name={school_list[1].name} year={school_list[1].year} image={school_list[1].image} grade={school_list[1].grade} description={school_list[1].description} degree={school_list[1].degree} /></Fade>
            <Fade left><School name={school_list[2].name} year={school_list[2].year} image={school_list[2].image} grade={school_list[2].grade} description={school_list[2].description} degree={school_list[2].degree} /></Fade>
            <Footer/>

        </div>
    )
}

export default Education;